import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { ErrorMessage } from '@sdir/utilities/lib/components';
import { DispensationExtended } from '@sdir/blueprint.aps/lib/components';
// eslint-disable-next-line max-len
import { DispensationServiceFeaturesDispensationsSharedDispensationDto as DispensationDto } from '@sdir/httpclient/lib/clients/aps/dispensation';
import { AlertSingleLine } from '@sdir/sds';
import { dispensationApi } from '../../../httpclient';

const DispensationPage: React.FC = () => {
  const intl = useIntl();
  const { uid } = useParams<{ uid: string }>();
  const [searchError, setSearchError] = useState(null);
  const [dispensation, setDispensation] = useState<DispensationDto>();

  useEffect(() => {
    dispensationApi
      .verifyDispensation(uid)
      .then((response) => {
        if (response.status === 200) {
          setDispensation(response.data);
        }
      })
      .catch((error) => {
        setSearchError(error);
        setDispensation(undefined);
      });
  }, [uid]);

  return (
    <Wrapper>
      {dispensation && dispensation?.status !== 'Cancelled' && (
        <DispensationWrapper translate="no">
          <DispensationExtended
            dateOfBirth={dispensation?.seafarer?.dateOfBirth || ''}
            name={dispensation?.seafarer?.name || ''}
            issuedDate={dispensation?.issuedAt}
            certificateName={dispensation?.certificateName}
            authorizedOfficial={dispensation?.authorizedOfficial}
            callsign={dispensation?.vessel?.callSign}
            dispensationNr={dispensation?.dispensationNumber}
            legalAuthority={dispensation?.legalAuthority}
            nationality={dispensation?.seafarer?.nationality || ''}
            occupationName={dispensation?.occupationTitle}
            remarks={dispensation?.remark || ''}
            validFrom={dispensation?.periodStart}
            validTo={dispensation?.periodEnd}
            vesselName={dispensation?.vessel?.name}
            hideQr
            qrImageLoading={false}
            // eslint-disable-next-line max-len
            qrData={`${process.env.REACT_APP_VERIFY_URL}/dispensation/${dispensation?.dispensationNumber}`}
            hideLanguageSelector
          />
        </DispensationWrapper>
      )}
      {dispensation?.status === 'Cancelled' && (
        <AlertSingleLine
          title=""
          text={intl.formatMessage({ id: 'dispensation.notvalid' })}
          type="info"
        />
      )}
      {searchError && <ErrorMessage error={searchError} />}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-top: 2em;
`;

const DispensationWrapper = styled.div`
  p {
    margin: 0;
  }
`;

export default DispensationPage;
